import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../common/SharedComponents';

import { LoanPageType } from '../../../loans/common/LoanConstants';
import InsuranceLandingPage from '../../../loans/insurance/InsuranceLandingPage';

export default function InsurancesRoutes() {
    return (
        <>
            <Route
                path='/loans/insurance/loc'
                element={
                    <RequireAdmin>
                        <InsuranceLandingPage pageType={LoanPageType.LOC} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/insurance/construction'
                element={
                    <RequireAdmin>
                        <InsuranceLandingPage pageType={LoanPageType.Construction} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/insurance/rental'
                element={
                    <RequireAdmin>
                        <InsuranceLandingPage pageType={LoanPageType.Rental} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/insurance/buildrent'
                element={
                    <RequireAdmin>
                        <InsuranceLandingPage pageType={LoanPageType.BuildRent} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/insurance/fixflip'
                element={
                    <RequireAdmin>
                        <InsuranceLandingPage pageType={LoanPageType.FixFlip} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/insurance/land'
                element={
                    <RequireAdmin>
                        <InsuranceLandingPage pageType={LoanPageType.Land} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/insurance/model'
                element={
                    <RequireAdmin>
                        <InsuranceLandingPage pageType={LoanPageType.Model} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/insurance/bridge'
                element={
                    <RequireAdmin>
                        <InsuranceLandingPage pageType={LoanPageType.Bridge} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/insurance'
                element={
                    <RequireAdmin>
                        <InsuranceLandingPage pageType={LoanPageType.Landing} />
                    </RequireAdmin>
                }
            />
        </>
    );
}
